import styled from "@emotion/styled";
import { type Opportunity } from "@repo/api";
import { LightMode, Variables } from "@repo/skapa";

import { ProjectSummary } from "./ProjectSummary";
import { RecommendedActions } from "./RecommendedActions";

interface ProjectSummaryContentProps {
  opportunity: Opportunity;
}

const Container = styled.div`
  border: ${Variables.thicknessThin} solid ${LightMode.colourNeutral3};
  border-radius: ${Variables.radiusM};
`;

const Main = styled.div`
  padding: ${Variables.space100};
`;

export const ProjectSummaryContent = ({
  opportunity,
}: ProjectSummaryContentProps) => {
  if (!opportunity.aiProjectData) {
    return null;
  }

  return (
    <Container>
      <Main>
        <ProjectSummary opportunity={opportunity} />

        <RecommendedActions
          actions={opportunity.aiProjectData.nextBestActions ?? []}
          opportunity={opportunity}
        />
      </Main>
    </Container>
  );
};
